import { render, staticRenderFns } from "./GigExtensionReview.vue?vue&type=template&id=6a3c9736&scoped=true&"
import script from "./GigExtensionReview.vue?vue&type=script&lang=js&"
export * from "./GigExtensionReview.vue?vue&type=script&lang=js&"
import style0 from "./GigExtensionReview.vue?vue&type=style&index=0&id=6a3c9736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c9736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
